
declare global {
    function assert(condition: unknown, message?: string): asserts condition;
}

(globalThis as any).assert = function (condition: unknown, message = 'Assertion failed'): asserts condition {
    if (!condition) {
        throw new Error(message);
    }
};

import * as import_1 from ".\/prolog.js";
import * as import_2 from ".\/themes\/raumgut\/scripts\/AbstractTransitionManager";
import * as import_3 from ".\/themes\/raumgut\/scripts\/Accordion";
import * as import_4 from ".\/themes\/raumgut\/scripts\/ActiveTrail";
import * as import_5 from ".\/themes\/raumgut\/scripts\/AjaxSearch";
import * as import_6 from ".\/themes\/raumgut\/scripts\/CloneFactory";
import * as import_7 from ".\/themes\/raumgut\/scripts\/Counter";
import * as import_8 from ".\/themes\/raumgut\/scripts\/DPlexArguments";
import * as import_9 from ".\/themes\/raumgut\/scripts\/DPlexForm";
import * as import_10 from ".\/themes\/raumgut\/scripts\/DPlexLoader";
import * as import_11 from ".\/themes\/raumgut\/scripts\/FormResetButton";
import * as import_12 from ".\/themes\/raumgut\/scripts\/FormSubmitHandler";
import * as import_13 from ".\/themes\/raumgut\/scripts\/Hamburger";
import * as import_14 from ".\/themes\/raumgut\/scripts\/Menu";
import * as import_15 from ".\/themes\/raumgut\/scripts\/Modal";
import * as import_16 from ".\/themes\/raumgut\/scripts\/Notify";
import * as import_17 from ".\/themes\/raumgut\/scripts\/ScrollToTop";
import * as import_18 from ".\/themes\/raumgut\/scripts\/SelectToTabs";
import * as import_19 from ".\/themes\/raumgut\/scripts\/Sidepane";
import * as import_20 from ".\/themes\/raumgut\/scripts\/Slider";
import * as import_21 from ".\/themes\/raumgut\/scripts\/SliderNavigation";
import * as import_22 from ".\/themes\/raumgut\/scripts\/SliderNavigationDynamic";
import * as import_23 from ".\/themes\/raumgut\/scripts\/SmoothScroll";
import * as import_24 from ".\/themes\/raumgut\/scripts\/StickyCollapsed";
import * as import_25 from ".\/themes\/raumgut\/scripts\/TabLoop";
import * as import_26 from ".\/themes\/raumgut\/scripts\/Tabs";
import * as import_27 from ".\/themes\/raumgut\/scripts\/TeaserOverlay";
import * as import_28 from ".\/themes\/raumgut\/scripts\/TransitionManager";
import * as import_29 from ".\/themes\/raumgut\/scripts\/VisibilityObserver";
import * as import_30 from ".\/themes\/raumgut\/scripts\/animations\/AbstractAnimation";
import * as import_31 from ".\/themes\/raumgut\/scripts\/animations\/BaseAnimation";
import * as import_32 from ".\/themes\/raumgut\/scripts\/animations\/BaseAnimations";
import * as import_33 from ".\/themes\/raumgut\/scripts\/animations\/FadeAnimation";
import * as import_34 from ".\/themes\/raumgut\/scripts\/animations\/GroupAnimation";
import * as import_35 from ".\/themes\/raumgut\/scripts\/animations\/HeightAnimation";
import * as import_36 from ".\/themes\/raumgut\/scripts\/animations\/ScrollLeftAnimation";
import * as import_37 from ".\/themes\/raumgut\/scripts\/animations\/ScrollTopAnimation";
import * as import_38 from ".\/themes\/raumgut\/scripts\/animations\/SlideAnimation";
import * as import_39 from ".\/themes\/raumgut\/scripts\/animations\/WidthAnimation";
import * as import_40 from ".\/themes\/raumgut\/scripts\/engines\/AbstractEngine";
import * as import_41 from ".\/themes\/raumgut\/scripts\/engines\/JQueryEngine";
import * as import_42 from ".\/themes\/raumgut\/scripts\/engines\/WebAnimationEngine";
import * as import_43 from ".\/themes\/raumgut\/scripts\/player\/CustomPlayer";
import * as import_44 from ".\/themes\/raumgut\/scripts\/player\/Player";
import * as import_45 from ".\/themes\/raumgut\/scripts\/player\/VideoPlayer";
import * as import_46 from ".\/themes\/raumgut\/scripts\/promises\/EventPromise";
import * as import_47 from ".\/themes\/raumgut\/scripts\/promises\/ImageLoadPromise";
import * as import_48 from ".\/themes\/raumgut\/scripts\/promises\/TimeoutPromise";
import * as import_49 from ".\/themes\/raumgut\/scripts\/transitions\/AbstractTransition";
import * as import_50 from ".\/themes\/raumgut\/scripts\/transitions\/FadeTransition";
import * as import_51 from ".\/themes\/raumgut\/scripts\/transitions\/GroupOverlayTransition";
import * as import_52 from ".\/themes\/raumgut\/scripts\/transitions\/GroupTransition";
import * as import_53 from ".\/themes\/raumgut\/scripts\/transitions\/OverlayTransition";
import * as import_54 from ".\/themes\/raumgut\/scripts\/widgets\/Checkbox";
import * as import_55 from ".\/themes\/raumgut\/scripts\/widgets\/FileInput";
import * as import_56 from ".\/themes\/raumgut\/scripts\/widgets\/Select";
import * as import_57 from ".\/themes\/raumgut\/scripts\/widgets\/TextInput";
export const imports={
...import_1,
...import_2,
...import_3,
...import_4,
...import_5,
...import_6,
...import_7,
...import_8,
...import_9,
...import_10,
...import_11,
...import_12,
...import_13,
...import_14,
...import_15,
...import_16,
...import_17,
...import_18,
...import_19,
...import_20,
...import_21,
...import_22,
...import_23,
...import_24,
...import_25,
...import_26,
...import_27,
...import_28,
...import_29,
...import_30,
...import_31,
...import_32,
...import_33,
...import_34,
...import_35,
...import_36,
...import_37,
...import_38,
...import_39,
...import_40,
...import_41,
...import_42,
...import_43,
...import_44,
...import_45,
...import_46,
...import_47,
...import_48,
...import_49,
...import_50,
...import_51,
...import_52,
...import_53,
...import_54,
...import_55,
...import_56,
...import_57,
}
